import { HierarchyItem } from '../types';
import { FilterTypes } from './types';

export const isStaleFilter = (
  originalFilter: FilterTypes,
  hierarchy: HierarchyItem[]
) => {
  if (hierarchy.length === 0) return true;
  const filterExistsInHierarchy = (h: HierarchyItem[]): boolean =>
    h.some(
      (i) =>
        i.key.hash === originalFilter.key.hash ||
        (i.subItems && filterExistsInHierarchy(i.subItems))
    );

  const hierarchyDimension = hierarchy[0].dimension;
  const sameDimension =
    hierarchyDimension.dataType === originalFilter.dataType &&
    hierarchyDimension.dataField === originalFilter.property;

  return sameDimension && !filterExistsInHierarchy(hierarchy);
};
